import { isEmpty } from 'lodash'

import axiosInstance from 'api/axiosInstance'
import {
    type ITicketDetailsResponse,
    type ITicketsResponse
} from 'pages/support/pages/Tickets/types/interfaces/ITicket'

export const addTicket = async (ticket: FormData) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/zendesk/ticket',
        data: ticket
    })
    return data
}

export const addComment = async (comment: FormData) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/zendesk/ticket/comment',
        data: comment
    })
    return data
}

export const getTickets = async () => {
    const { data } = await axiosInstance<ITicketsResponse>({
        method: 'GET',
        url: `/api/zendesk/ticket`
    })
    return data?.data
}

export const getTicketDetails = async (id: string | null) => {
    const { data } = await axiosInstance<ITicketDetailsResponse>({
        method: 'GET',
        url: `/api/zendesk/ticket/${id}`
    })
    return data
}

export const deleteTicket = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/zendesk/ticket/${id}`
    })
    return data
}

export const searchTickets = async (page: number, searchTerm: string) => {
    let apiString
    if (!isEmpty(searchTerm)) {
        apiString = `/api/zendesk/tickets/search?query=${searchTerm}&page=${page}`
    } else {
        apiString = `/api/zendesk/tickets?page=${page}`
    }

    const { data } = await axiosInstance<ITicketsResponse>({
        method: 'GET',
        url: apiString
    })

    return data.data
}

export const closeTicket = async (id: string) => {
    console.log('Closing ticket ID:', id);
    const { data } = await axiosInstance({
      method: 'PUT',
      url: `/api/zendesk/ticket/${id}`,
    });
  
    return data;
  };

export const deleteComment = async (
    ticketId: string,
    commentId: string | number
) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/zendesk/ticket/${ticketId}/comment/${commentId}`
    })

    return data
}